export default "__VITE_ASSET__d$1ipdiZ__"